export default __webpack_public_path__ + "static/media/not-successful.34a9c887.svg";